"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = require("graphql-tag");
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
const reducers_1 = require("../reducers");
exports.fetchNotificationReport = (ID) => (dispatch, getState) => {
    const state = getState();
    const campaignReport = reducers_1.getCampaignReport(state);
    dispatch({ type: 'FETCH_NOTIFICATION_DELIVERED_REPORT_REQUEST' });
    const query = graphql_tag_1.default `
            query fetchNotificationReport($campaignID: ID!) {
                notificationDeliveredReport(campaignID: $campaignID) {
                    totalDelivered
                    notificationCenterAttempted
                    notificationCenterDelivered
                    notificationCenterUnreachable
                    notificationCenterInvalid
                    pushAttempted
                    pushDelivered
                    pushUnreachable
                    pushInvalid
                }
                notificationOpenedReport(campaignID: $campaignID) {
                    total
                    unique
                    notificationCenterTotal
                    notificationCenterUnique
                    pushDirectTotal
                    pushDirectUnique
                    pushInfluencedTotal
                    pushInfluencedUnique
                }
                experienceReport(campaignId: $campaignID) {
                    averageSession
                    blockClicks {
                        ID
                        screenID
                        name
                        count
                    }
                    screenViews {
                        ID
                        name
                        count
                    }
                }
            }
        `;
    const request = {
        query,
        variables: { campaignID: ID },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_NOTIFICATION_DELIVERED_REPORT_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'FETCH_NOTIFICATION_DELIVERED_REPORT_SUCCESS',
            campaignReport: Object.assign(Object.assign({}, campaignReport), { notificationDeliveredReport: data.notificationDeliveredReport, notificationOpenedReport: data.notificationOpenedReport }),
            experienceReport: data.experienceReport,
        });
    }, ({ result }) => handleError_1.default('FETCH_NOTIFICATION_DELIVERED_REPORT_FAILURE', dispatch, result.errors[0].message));
};
exports.clearCampaignReport = () => (dispatch) => {
    dispatch({
        type: 'CLEAR_CAMPAIGN_REPORT',
        campaignReport: {
            notificationDeliveredReport: {},
            notificationOpenedReport: {},
        },
        experienceReport: {
            averageSession: 0,
            blockClicks: [],
            screenViews: [],
        },
    });
};
